import { Injector } from '@angular/core';
import { Router } from '@angular/router';
import {
  ActionButtonOutcomesType,
  BaseWidgetProperties,
  ConfirmationClaimType,
} from '@finxone-platform/shared/sys-config-types';
import { Store } from '@ngxs/store';
import { ConfigService } from '../../../services/config-service/config-service.service';
import { ConfirmationService } from '../../../services/confirmation-service/confirmation-service';
import { ProjectSettingsState } from '../../../state/project-settings.state';
import { createRedirectionUrlFromNavigationOptions } from '../../utils';
import { submitDomesticPaymentRequest } from './submit-payment-request';

/**
 * Checks the SMS authentication status from the project settings and redirects
 * based on the status. If SMS authentication is enabled, it redirects to the
 * specified page using the provided widget properties. If not enabled, it sets
 * the navigation URL to 'payment-processing', submits a domestic payment request,
 * and then redirects.
 *
 * @param widgetProperties - The properties of the widget, including navigation details.
 * @param injector - The Angular injector used to retrieve services.
 */
export function checkAuthSmsStatusAndRedirect(widgetProperties: BaseWidgetProperties, injector: Injector) {
  const store = injector.get(Store);
  const configService = injector.get(ConfigService);
  const router = injector.get(Router);
  const confirmationService = injector.get(ConfirmationService);
  const isSmsAuthEnabled = store.selectSnapshot(
    ProjectSettingsState.getProjectSettings,
  ).smsAuthenticationEnabled;

  let targetUrl = configService.reRouteIfModal(widgetProperties['zoneToNavigate'], 'payment-processing');

  // check if navigation config exist for processing state and update the targetUrl
  if (widgetProperties?.actionNavigationConfigurations?.[ActionButtonOutcomesType.PROCESSING]) {
    targetUrl = createRedirectionUrlFromNavigationOptions(
      widgetProperties.actionNavigationConfigurations[ActionButtonOutcomesType.PROCESSING],
    );
  }

  if (isSmsAuthEnabled) {
    const subscription = confirmationService.checkConfirmation(targetUrl).subscribe(() => {
      submitDomesticPaymentRequest(injector, widgetProperties);
      subscription.unsubscribe();
    });
    confirmationService.confirmAction(ConfirmationClaimType.MAKE_PAYMENT, targetUrl);
  } else {
    widgetProperties['urlToNavigate'] = 'payment-processing';
    submitDomesticPaymentRequest(injector, widgetProperties);
    router.navigateByUrl(targetUrl);
  }
}
